import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/decision-time/headerRightBg.png';
import headerRightBg375 from '../images/decision-time/headerRightBg375.png';
import MenPaperAirplane from '../images/decision-time/MenPaperAirplane.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import Gears from '../images/decision-time/Gears.svg';
import Scales from '../images/decision-time/Scales.svg';
import HourGlass from '../images/decision-time/HourGlass.svg';
import GearsPaperAirplane from '../images/decision-time/GearsPaperAirplane.svg';
import WantToSeeHow from '../components/WantToSeeHow';

import Testimonial from '../components/Testimonial';
import KevinTweedle from '../images/decision-time/kevinTweedle.jpg';
import icbaServiceNetwork from '../images/decision-time/icba_service_network.png';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const DecisionTimeHeaderContent =
	<HeaderContent style={{marginTop: `60px`, paddingBottom: `40px`}}>
		<h1>DecisionTime</h1>
		<p>Rules-based credit<br />decisioning automation</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 90%;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-bottom: 2.5em;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
		}
	}
`;

const MenPaperAirplaneFigure =
	<HeaderBottomContentFigure>
		<MenPaperAirplane alt='Men throwing paper airplane at pile of papers' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	border: none;
`;

const FeaturesAndBenefitsSyle = { marginBottom: `0` };

const problemExtraStyle = { paddingRight: `0` };

const DecisionTimePage = (props: any) => {
	return (
	<Layout
		headerSplashBg={headerRightBg}
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPosition={'center top'}
		headerSplashBgPositionLarge={'center top'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={MenPaperAirplaneFigure}
		headerContentClass={'product'}
		headerContent={DecisionTimeHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='DecisionTime - Digitized underwriting workflows'
		metaDescription={'Digitize your underwriting process with automated or manual decisioning to reduce overhead, ensure regulatory compliance, and provide real-time responses.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'467px'}
		BodyClass={'DecisionTime'}
	>
		<ProblemSolution
			problem={'Customers seeking rapid credit decisions are migrating away from financial institutions who lack technology.'}
			solution={'DecisionTime meets rising customer demands for fast responses by automating the underwriting process.'}
			problemExtraStyle={problemExtraStyle}
		/>
		<Testimonial
			portrait={KevinTweedle}
			portraitAlt={'Kevin Tweddle'}
			name={'Kevin Tweddle'}
			title={'CPA and COO,'}
			company={'ICBA Services Network'}
			quote={'This game changing digital lending platform is a high-tech underwriting solution that leaves more room for high-touch community bank-customer relationships. By reducing the decision-making process down to seconds, community banks and their customers save valuable time without sacrificing the community bank quality service that they know and value.'}
			logo={icbaServiceNetwork}
			logoAlt={'ICBA Logo'}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#3ed8c3'}

			leftIcon = {<Gears alt='gears icon' style={{margin: `3px 0`}} />}
			leftHeading = {'Configurable\nunderwriting processes'}
			leftText={'Choose freely between automated or manual underwriting.'}

			middleIcon = {<Scales alt='scales icon' style={{margin: `0 0`}} />}
			middleHeading = {'Rules-based\ndecisioning'}
			middleText = {'Manage risk by enforcing credit policy fairly and consistently.'}

			rightIcon = {<HourGlass alt='hour glass icon' style={{margin: `3px 0`}} />}
			rightHeading = {'Real-time\nresponses'}
			rightText = {'Increase customer satisfaction with quick turnaround times.'}
		/>
		<div className='centeredWrapper'>
			<Section className='strategic-fraud row row-flush centered'>
				<article className='col-12 col-md-6 right-on-desktop'>
					<div className='product text-box'>
						<header>
							<h2>Say hello to digitized underwriting</h2>
						</header>
						<p>Applying for a loan is one of the most stressful things that people do. And in the age of immediacy, customers expect quick responses from their financial institutions.</p><p>Say hello to a flexible, digitized underwriting process with a rules-based decisioning engine. Ensure regulatory compliance, reduce overhead, and increase ROI with the ability to decision thousands of data points in seconds.</p>
					</div>
				</article>
				<figure className='col-12 col-md-6 left-on-desktop' id='GearsPaperAirplane'>
					<GearsPaperAirplane alt='Paper airplane over gears' />
				</figure>
			</Section>
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default DecisionTimePage;
